export const h = {
  system: "English",
  CompanyProfile:'企业简介',
  GrowthProcess:"成长历程",
  MainBusiness:'主营业务',
  BusinessData:'经营数据',
  CoreCompetitiveness:'核心竞争力',
  ContactInformation:'联系方式',
  CompanyName:'铁马高尔夫',
  Service:'高尔夫综合服务运营商',
  BGT:'订场·旅游',
  ABE:'年订场量70万人/次（18洞）',
  MS:'会籍代理',
  AGENT:'全国40余家球会产品总代理',
  SHM:'二手会籍交易',
  EO:"赛事承办",
  HOLCEA:'每年超500场商业赛事',
  TGPS:'高尔夫商城',
  SIC:'全国25家直营专卖店',
  NM:'新媒体',
  MCALSR:'媒体报道与直播间',
  SS:'专职销售',
  PT:'技术团队',
  TCC:'三大客服中心',
  ShenZhen:'深圳',
  BeiJing:'北京',
  ShangHai:'上海',
  TeamAdvantage:'团队优势',
  Customerbase:'客户基础',
  ServiceSystem:'服务体系',
  Brand:'品牌',
  TTBGT:'订场.旅游',
  CACC:'21年客户积累',
  COGE:'覆盖80%以上高尔夫人群',
  TemaApp:'铁马APP',
  MiniApp:'小程序',
  NewMedia:'新媒体',
  PhysicalStore:'实体店',
  SalesTeam:'销售团队',
  TournamentTeam:'赛事团队',
  experience:'21年沉淀',
  CR:'客户认同',
  CV:'行业认同',

};
